module.exports = __webpack_public_path__ + "img/3.444170f9.jpg";